module.exports = __webpack_public_path__ + "img/12.be0d4c96.jpg";